import { Actions, ActionTypes, HardshipState } from "./types";

export const hardshipReducer = (
  state: HardshipState,
  action: Actions,
): HardshipState => {
  switch (action.type) {
    case ActionTypes.START_APPLICATION: {
      return {
        ...state,
        isStarted: true,
      };
    }
    case ActionTypes.COMPLETE_PRESCREENING: {
      const { type: _, ...payload } = action;
      return {
        ...state,
        prescreening: payload,
      };
    }
    case ActionTypes.COMPLETE_PERSONAL_DETAILS: {
      const { type: _, ...payload } = action;
      return {
        ...state,
        personalDetails: payload,
      };
    }
    case ActionTypes.COMPLETE_YOUR_ACCOUNTS: {
      const { type: _, ...payload } = action;
      return {
        ...state,
        yourAccounts: payload,
      };
    }

    case ActionTypes.COMPLETE_REASONS_FOR_APPLYING: {
      const { type: _, ...payload } = action;
      return {
        ...state,
        reasonsForApplying: payload,
      };
    }

    case ActionTypes.COMPLETE_YOUR_INCOME: {
      const { type: _, ...payload } = action;
      return {
        ...state,
        yourIncome: payload,
      };
    }

    case ActionTypes.COMPLETE_EXPENSES: {
      const { type: _, ...payload } = action;
      return {
        ...state,
        expenses: payload,
      };
    }

    case ActionTypes.COMPLETE_LIABILITIES: {
      const { type: _, ...payload } = action;
      return {
        ...state,
        liabilities: payload,
      };
    }

    case ActionTypes.SUBMIT_SUCCESS: {
      return {
        ...state,
        review: {
          acknowledge: {
            shoppingBlock: true,
            debitCardAgreement: true,
            termsAndConditions: true,
            privacyPolicy: true,
            maintainingPayments: true,
            revisedLoan: true,
          },
          ticketId: action.ticketId,
        },
      };
    }
    default:
      return state;
  }
};
